import type {
  BookingEventDetail,
  BookingEventRegistrationFormValues,
  BookingEventService,
} from '@/types';

export const registeredIn = (
  event: BookingEventDetail,
  waveId: number | null,
): { service: BookingEventService } | null => {
  if (!event.split_into_waves) {
    return event.service && { service: event.service };
  }

  return event.waves.find((wave) => wave.id === waveId) ?? null;
};

const customFieldAnswersAttributes = (values: Record<string, string>) =>
  Object.entries(values)
    .filter(([, value]) => value.trim() !== '')
    .map(([fieldId, value]) => ({
      service_custom_field_id: Number(fieldId),
      value: value.trim(),
    }));

export const createEventRegistrationPayload = (
  values: BookingEventRegistrationFormValues,
  waveId: number | null,
) => ({
  registration: {
    event_wave_id: waveId,
    client_id: values.client_id ? Number(values.client_id) : null,
    guest_info: values.client_id ? null : values.guest_info.trim() || null,
    note: values.note.trim() || null,
    staff_comment: values.staff_comment.trim() || null,
    channel: 'admin',
    custom_field_answers_attributes: customFieldAnswersAttributes(
      values.custom_field_values,
    ),
  },
});
